export default {
notification: {
  read: "Sudah dibaca",
  unread: "Belum dibaca",
  hide: "Sembunyikan",
  showAll: "Tampilkan semua",
  loading: "Memuat...",
  noMore: "Tidak ada data lagi",
  platform: "Platform",
  personal: "Pribadi"
}
};
